import { Buyer } from '@typings';

import { isDefined } from '../utils/is';

export const getAccountNameWithId = (buyer: Buyer.ListElement) => buyer.account && `#${buyer.account.id} ${buyer.account.name}`;

export const getBuyerFullName = (buyer: Buyer.ListElement) => [buyer.firstName, buyer.lastName].filter(isDefined).join(' ');
